import ContentPreview from "../../CourseApp/Content/ContentPreview";

function Content({slides, selectedSlide, selectedSlideIndex, lessonTitle}) {
    return (
        <div className='tbcourse-preview'>
            <h3 className='font-size-22 font-weight-700 mb-3'>Page Preview</h3>
            <div className="tbcourse-body tbcourse-content-body">
                <ContentPreview
                    slides={slides}
                    selectedSlide={selectedSlide}
                    selectedSlideIndex={selectedSlideIndex}
                    lessonTitle={lessonTitle} />
            </div>
        </div>
    );
}

export default Content;